export const useCasesQueryKeys = {
  root: ["useCases"] as const,
  list: () => ["useCases", "list"] as const,
  adminList: () => ["useCases", "adminList"] as const,
  detail: (id: string) => ["useCases", "detail", id] as const,
  participants: (id: string) => ["useCases", "participants", id] as const,
} as const
